/* Beginner's Guide Tabs Section - accessible tab logic */
(function () {
  function initGuideTabs(root) {
    var navButtons = root.querySelectorAll('.guide-tabs__nav-item');
    var panels = root.querySelectorAll('.guide-tabs__panel');

    if (!navButtons.length || !panels.length) return;

    function activate(index, moveFocus) {
      navButtons.forEach(function (btn, i) {
        var isActive = i === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (moveFocus) {
        navButtons[index].focus();
      }
    }

    navButtons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        activate(index, false);
      });

      btn.addEventListener('keydown', function (event) {
        var newIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = (index + 1) % navButtons.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = (index - 1 + navButtons.length) % navButtons.length;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = navButtons.length - 1;
        }

        if (newIndex !== null) {
          event.preventDefault();
          activate(newIndex, true);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-guide-tabs]').forEach(initGuideTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a block/section is added or the section re-renders in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var tabsRoot = event.target.querySelector('[data-guide-tabs]');
    if (tabsRoot) initGuideTabs(tabsRoot);
  });
})();
